
import { defineComponent, inject } from "vue";
import CongestionLevelIcon from "@/components/CongestionLevelIcon.vue";
import { AdminAPIClientKey } from "@/symbols";
import AdminAPIClient, {
  CongestionLevelResponse,
} from "@/domain/repository/admin_api_client";

type DataType = {
  congestionLevel: number;
  timestamp?: Date;
};

export default defineComponent({
  setup() {
    const adminAPIClient: AdminAPIClient | undefined = inject(
      AdminAPIClientKey
    );
    return {
      adminAPIClient,
    };
  },
  data(): DataType {
    return {
      congestionLevel: 0,
      timestamp: undefined,
    };
  },

  computed: {
    congestionLevelLabel(): string {
      switch (this.congestionLevel) {
        case 1:
          return "空いています";

        case 2:
          return "やや混んでいます";

        case 3:
          return "混んでいます";

        default:
          return "";
      }
    },

    timestampLabel(): string {
      const ts = this.timestamp;
      if (ts === undefined) {
        return "";
      }
      return `${ts.getHours()}時${ts.getMinutes()}分`;
    },
  },

  methods: {
    async fetchCongestionLevel(): Promise<CongestionLevelResponse> {
      const mac = this.$route.query.mac?.toString();
      if (mac === undefined || mac === "") {
        return Promise.reject("mac is empty");
      }
      return this.adminAPIClient!.getCongestionLevel(mac);
    },

    async refreshDeviceCongestionLevel(): Promise<void> {
      this.fetchCongestionLevel().then((res) => {
        this.congestionLevel = res.congestionLevel.level ?? 0;
        this.timestamp = res.congestionLevel.ts;
      });
    },
  },

  mounted() {
    this.refreshDeviceCongestionLevel().then();
    setInterval(this.refreshDeviceCongestionLevel, 15000);
  },

  components: {
    CongestionLevelIcon,
  },
});
